import RegistryDiscount from './registry-discount'

export default RegistryDiscount
